document.querySelectorAll('button.carat-previous').forEach(button => {
  button.addEventListener('click', event => {
    let container = button.closest('div').querySelector('div.grid-overflow-wrapper');
    let scrollAmount = button.closest('div').querySelector('div.grid__item').getBoundingClientRect().width;
    container.scrollLeft -= scrollAmount;
  })
})

document.querySelectorAll('button.carat-next').forEach(button => {
  button.addEventListener('click', event => {
    let container = button.closest('div').querySelector('div.grid-overflow-wrapper');
    let scrollAmount = button.closest('div').querySelector('div.grid__item').getBoundingClientRect().width;
    container.scrollLeft += scrollAmount;
  })
})